import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { IoClose } from "react-icons/io5";
import { Box, Grid, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import { GeneratePaymentLink } from 'API/DsPaymentLink/api';
import { useEffect } from 'react';

export default function PaymentDialog(props) {

    const [AmountData, setAmountData] = useState({ refundable_amount: 0, non_refundable_amount: 0 })
    const [IsLoading, setIsLoading] = useState(false)


    const handleChange = (field, value) => {
        if (/^[0-9.]+$/.test(value)) {
            if (value === ".") {
                // Prevent multiple decimals
                if (!AmountData[field]?.toString().includes(".")) {
                    setAmountData({ ...AmountData, [field]: value });
                }
            } else {
                setAmountData({ ...AmountData, [field]: Number(value) });
            }
        } else if (value === "") {
            setAmountData({ ...AmountData, [field]: 0 });
        }

    }

    console.log("props at payment", props);


    useEffect(() => {
        if (!props.open) {

            setAmountData({ refundable_amount: 0, non_refundable_amount: 0 })
        }
        else {
            let nonRefundable = props.id && props.id.distributor_services_type === "FI" ? 25000 : props.id.distributor_services_type === "NON FI" ? 5000 : props.id.distributor_services_type === "ATBC" ? 25000 : 0
            setAmountData({ refundable_amount: 0, non_refundable_amount: nonRefundable })
        }
    }, [props.open])

    const handleSubmit = () => {
        if (AmountData.refundable_amount === 0 && AmountData.non_refundable_amount === 0) {
            props.handleAlertOpen("Please enter amount", "error")
        }
        else {
            let data = {
                "user_id": props.id.user_id,
                "customer_name": props.id.distributor_name,
                "bill_delivery_type": "BOTH",
                "customer_mobile_no": props.id.mobile_number_1,
                "customer_email_id": props.id.email_address,
                "customer_email_subject": "Distributor on-boarding",
                "invoice_description": "Distributor_onboarding",
                "valid_type": "days",
                "valid_for": 2,
                "refundable_amount": AmountData.refundable_amount,
                "non_refundable_amount": AmountData.non_refundable_amount,
                "total_amount": AmountData.refundable_amount + AmountData.non_refundable_amount,
                "user_type": "DS"
            }
            GeneratePaymentLink(data, setIsLoading, props.handleAlertOpen, props.handleClose, props.handleGet)
        }


    }

    console.log("props for payment", props);



    return (
        <React.Fragment>

            <Dialog
                open={props.open}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth
                maxWidth="md"
            >
                <DialogTitle id="alert-dialog-title">
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ position: 'absolute', top: 10, right: 10, cursor: 'pointer', fontSize: '25px' }} onClick={props.handleClose}>
                        <IoClose />
                    </Box>
                    <DialogContentText id="alert-dialog-description">
                        <Grid container spacing={2}>
                            <Grid item md={4} xs={12}>
                                <Typography variant='h6'>Refundable Amount</Typography>
                                <TextField
                                    size='small'
                                    fullWidth
                                    id="outlined-basic"
                                    variant="outlined"
                                    value={AmountData.refundable_amount}

                                    onChange={(e) => handleChange("refundable_amount", e.target.value)}

                                />
                            </Grid>

                            <Grid item md={4} xs={12}>
                                <Typography variant='h6'>Non Refundable Amount</Typography>
                                <TextField
                                    size='small'
                                    fullWidth
                                    id="outlined-basic"
                                    value={AmountData.non_refundable_amount}
                                    variant="outlined"
                                    inputProps={
                                        {
                                            readOnly: props.id && props.id.distributor_services_type === "AECS" ? false : true
                                        }
                                    }
                                    onChange={(e) => handleChange("non_refundable_amount", e.target.value)}
                                />
                            </Grid>

                            <Grid item md={4} xs={12}>
                                <Typography variant='h6'>Total Amount</Typography>
                                <TextField
                                    size='small'
                                    fullWidth
                                    id="outlined-basic"
                                    variant="outlined"
                                    value={AmountData.refundable_amount + AmountData.non_refundable_amount}
                                    inputProps={{
                                        // disabled: props.amount <= 0,
                                        readOnly: true
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Button disabled={IsLoading} size='small' color='secondary' variant='contained' onClick={handleSubmit}>{IsLoading ? "Loading..." : "Proceed"}</Button>

                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}